import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export const Footer = () => {
  const [wa, setWa] = useState("");
  useEffect(() => { api.get("/config").then((r) => setWa(r.data.whatsapp)).catch(() => {}); }, []);

  return (
    <footer data-testid="site-footer" className="bg-[hsl(var(--secondary))] text-white/90">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-20 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <img src="/logo.png?v=2" alt="Navrang Udaipur" className="w-20 h-20 rounded-full object-cover mb-6" />
          <h3 className="font-display text-4xl md:text-5xl leading-tight">Wearable heritage,<br /><span className="italic text-[hsl(var(--accent))]">block by block.</span></h3>
          <p className="font-body text-sm text-white/60 mt-6 max-w-sm">Hand block-printed Sanganeri shirts for men & children, crafted in the lanes of Udaipur, Rajasthan.</p>
        </div>
        <div className="md:col-span-3 md:col-start-8">
          <p className="overline text-white/40 mb-5">Explore</p>
          <ul className="space-y-3 font-body text-sm">
            <li><Link to="/shop" className="link-underline">Full Collection</Link></li>
            <li><Link to="/shop?category=men" className="link-underline">Men</Link></li>
            <li><Link to="/shop?category=children" className="link-underline">Children</Link></li>
            <li><Link to="/about" className="link-underline">Our Craft</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="overline text-white/40 mb-5">Reach us</p>
          <ul className="space-y-3 font-body text-sm">
            <li><Link to="/contact" className="link-underline">Contact</Link></li>
            <li><Link to="/track" className="link-underline">Track Order</Link></li>
            {wa && <li><a href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" className="link-underline">WhatsApp</a></li>}
            <li><Link to="/admin/login" className="link-underline text-white/40">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between gap-2 overline text-white/40">
          <span>© {new Date().getFullYear()} Navrang Udaipur</span>
          <span>Sanganer · Bagru · Udaipur</span>
        </div>
      </div>
    </footer>
  );
};
